<template>
    <div class="container-fluid mt-4">
        <div class="row">
            <div class="col-12">
                <cph-widget :tabs="overviewTabs"
                            :tab.sync="activeTab"
                            :activeTabName="activeTab.displayName"
                            :tabsByKey="true"
                            :standOut="true"
                            :closeable="false"
                            :tabKey="'displayName'">
                    <h2 slot="header">{{activeTab.displayName}}</h2>
                    <li slot="actionTabs" class="tab-item ml-auto" @click="handleTabChange({name: 'Register', data: null})"
                        v-if="activeTab.displayName === 'Users'">{{$t('REGISTRATION.addUser')}}</li>
                    <li slot="actionTabs" class="tab-item ml-auto" @click="handleTabChange({name: 'ShopRegister', data: null})"
                        v-else>{{$t('REGISTRATION.addShop')}}</li>
                    <div slot="body" slot-scope="slotProps">
                        <transition name="fade" mode="out-in">
                            <component :is="activeTab.componentName"
                                       :key="activeTab.componentName"
                                       @addUserToShop="addUserToShopHandler"
                                       @changeTab="handleTabChange"/>
                        </transition>
                    </div>
                </cph-widget>
            </div>
        </div>
        <transition name="fade" mode="out-in">
            <div class="row"  v-if="activeForm">
                <div class="col-12">
                    <cph-widget :activeTabName="activeForm.displayName"
                                :tabsByKey="true"
                                :key="activeForm.displayName"
                                :standOut="true"
                                :closeable="true"
                                @close="activeForm = null"
                                :tabKey="'displayName'">
                        <h2 slot="header">{{activeForm.displayName}}</h2>
                        <div slot="body">
                            <transition name="fade" mode="out-in">
                                <component :is="activeForm.componentName"
                                           :key="uid"
                                           :passedData="editData"
                                           @close="handleClose"
                                           @changeTab="handleTabChange"/>
                            </transition>
                        </div>
                    </cph-widget>
                </div>
            </div>
        </transition>
        <transition name="fade" mode="out-in">
            <functional-modal @close="showModal = false"
                              @save="saveUser"
                              key="product-modal"
                              :showModal="showModal"
                              :showSave="availableUsers.length > 0"
                              :title="$t('UI.add')"
                              v-if="showModal">
                <div :class="['col-12']" slot="body">
                    <multiselect v-model="usersToAdd"
                                 :options="availableUsers"
                                 :close-on-select="false"
                                 :hide-selected="true"
                                 :preserve-search="true"
                                 :multiple="true"
                                 placeholder="User to add"
                                 :custom-label="customLabel"
                                 :show-labels="false"
                                 trackBy="id" v-if="availableUsers.length > 0">
                        <template slot="tag" slot-scope="props">
                            <span class="custom__tag">
                                <span>{{props.option.name}}</span>
                                <span class="custom__remove" @click="props.remove(props.option)">❌</span>
                            </span>
                        </template>
                    </multiselect>
                    <div v-else>
                        <p class="text-center">{{$t('REGISTRATION.noUser')}}</p>
                    </div>
                </div>
            </functional-modal>
        </transition>
    </div>
</template>

<script type="text/babel">
import {RegistrationPerimeter} from '../../../router/perimeters/registrationPerimeter';
import CphWidget from '../../../components/Shared/CphWidget.vue';
import {mapActions, mapGetters, mapMutations} from 'vuex';
import Multiselect from 'vue-multiselect';
import FunctionalModal from '../../../components/Shared/Modal/FunctionalModal';
import UserRegistrationForm from '../../../components/Panel/Registration/User/UserRegistrationForm';
import UsersTable from '../../../components/Panel/Registration/User/UserTable';
import ShopsTable from '../../../components/Panel/Registration/Shops/ShopsTable';
import ShopRegistrationForm from '../../../components/Panel/Registration/Shops/ShopRegistrationForm';
import objectPath from 'object-path';
export default {
    name: 'Registration',
    data () {
        return {
            formPickerChosen: false,
            formType: null,
            showModal: false,
            shopSelected: null,
            usersToAdd: null,
            uid: '',
            editData: null,
            activeTab: {
                displayName: 'Users',
                componentName: 'users-table'
            },
            activeForm: null
        };
    },
    watch: {
        activeTab (newValue) {
            this.activeForm = null;
            if(newValue.displayName === 'Users') {
                this.editData = null;
            }
        }
    },
    computed: {
        ...mapGetters({
            users : 'getUsers',
            user: 'getUser'
        }),
        userIds () {
            let result = [];
            let {resultArray: userIds} = this.$utils.getNestedKeyPaths(this.users, 'id');
            userIds.forEach(user => {
                if(!user.path.includes('shops')) {
                    user.path.pop();
                    let extractedUser = objectPath.get(this.users, user.path);
                    if(extractedUser) {
                        let {id, person:{firstName, lastName}} = extractedUser;
                        result.push({id, name: `${firstName} ${lastName}`});
                    }
                }
            });
            return result;
        },
        availableUsers () {
            return this.shopSelected.users ?
                this.userIds.filter(({id}) => !this.shopSelected.users.find(user => user.id === id))
                : this.userIds;
        },
        overviewTabs () {
            return {
                Shops: {
                    displayName: 'Shops',
                    componentName: 'shops-table'
                },

                Users: {
                    displayName: 'Users',
                    componentName: 'users-table'
                }
            };
        },
        formTabs () {
            return {
                Register: {
                    displayName: 'Register',
                    componentName: 'user-registration-form'
                },
                ShopRegister: {
                    displayName: 'Register shop',
                    componentName: 'shop-registration-form'
                }
            };
        }
    },
    components: {
        CphWidget,
        Multiselect,
        FunctionalModal,
        UserRegistrationForm,
        UsersTable,
        ShopsTable,
        ShopRegistrationForm

    },
    perimeters: [
        RegistrationPerimeter
    ],
    methods: {
        ...mapActions(['AddShopToUser', 'addUserToShop', 'GetShopById', 'GetShopFromUser']),
        ...mapMutations(['updateShop', 'updateUserShopList']),
        customLabel (value) {
            return `${value.name}`;
        },
        handleTabChange ({name, data, parentId, parentRole}) {
            if(data || parentId) {
                this.activeForm = this.formTabs[name];
                this.editData = {...data, parentId, parentRole};
            } else {
                this.activeForm = this.formTabs[name];
                this.editData = null;
            }
            this.uid = this.$utils.shortid.generate();
        },
        handleClose () {
            this.formPickerChosen = false;
            this.formType = null;
            this.activeForm = null;
        },
        addUserToShopHandler (shop) {
            this.showModal = true;
            this.shopSelected = shop;
        },
        async saveUser () {
            await this.$utils.resolvePromises(this.usersToAdd.map(user => this.AddShopToUser({user: user, shop: this.shopSelected})));
            await this.addUserToShop({shopId: this.shopSelected.id, userIds: this.usersToAdd.map(user => ({id: user.id}))});
            let {data: shops} = await this.GetShopFromUser({id: this.user.id});
            this.updateUserShopList(shops);
            this.shopSelected = await this.GetShopById(this.shopSelected.id);
            this.updateShop(this.shopSelected);
            this.usersToAdd = null;
            this.showModal = false;
        }
    }

};
</script>

<style lang="scss">
    .user-table-row,.shop-table-row {
        padding: 0;
        border-bottom: 2px solid;
        @include color('border-color', primary);
    }

    .black-bg {
        background: black;
        color: white;
    }
</style>
